<template>
    <div class="card card-front text-center" :class="{ 'rotate-card-front': isFlipped }">
        <div class="card-header">
            <p>{{ title }}</p>
        </div>
        <div class="card-block p-3">
            <div class="imageBox">
                <img class="avatar" :src="avatar" alt="Avatar" />
            </div>
            <h4 class="card-title mb-0 mt-2">{{ fullname }}</h4>
            <h5 class="card-title mb-0">{{email}}</h5>
            <!-- <p class="fw-bold">{{ position }}</p> -->
            <div class="bottom-content">
                <button v-if="cv_url" class="btn btn-rotate mt-2 mb-0" @click="openCV">
                   {{this.$t('autoret.prokurorettitujt.shiko')}} &nbsp; <font-awesome-icon icon="fa-solid fa-file-pdf" style="color:var(--color-system-secondary);" />
                </button>
               
            </div>
        </div>
    </div>
</template>

<script>  
export default {
    name: 'ProfileCard',
    props: {
        title: { type: String, default: 'Kryeprokurori' },
        avatar: { type: String, required: true },
        fullname: { type: String, required: true },
        position: { type: String, required: true },
        birthday: { type: String, default: '' },
        address: { type: String, default: '' },
        facebook: { type: String, default: '#' },
        cv_text: { type: String, default: '' },
        cv_url: { type: String, default: '' },
        email: { type: String, default: '' }
    },
    data() {
        return {
            isFlipped: false,
            showModal: false,
        }
    },
    components: {

    },
    methods: {
        openCV() {
            if (this.cv_url) {
                window.open(this.cv_url, '_blank');
            }
        }
    }
}
</script>

<style scoped>
/* Card styles for rotation */
.rotate-container {
    position: relative;
}

.rotate-container .card-front,
.rotate-container .card-back {
    width: 90%;
    height: 350px;
    transform: perspective(600px) rotateY(0deg);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: all 0.5s linear 0s;
}

.rotate-container .card-back {
    transform: perspective(1600px) rotateY(180deg);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.rotate-container .rotate-card-front {
    transform: perspective(1600px) rotateY(-180deg);
}

.rotate-container .rotate-card-back {
    transform: perspective(1600px) rotateY(0deg);
}

/* Modified card styles */
.card {
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.5);
    height: 400px;
    display: flex;
    flex-direction: column;
}


.card .card-background {
    background: url("https://static.pexels.com/photos/443374/pexels-photo-443374.jpeg");
    height: 80px;
    background-position: center center;
    background-size: cover;
}

.card .avatar {
  width: 100%;        
  height: 100%;        
  aspect-ratio: 3 / 2;
  -o-object-fit: contain;
  object-fit: contain;
}

.card .btn {
    margin-bottom: 1em;
    cursor: pointer;
}

.card .social-links li {
    margin: 0.5em;
}

.card .social-links a {
    font-size: 1.5em;
}

button {
    width: 150px;
    background-color: var(--color-system-primary);
}

button:hover {
    background-color: var(--color-system-secondary);
    color: white;
}

.card-header {
    background-color: var(--color-system-secondary);
    color: white;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

}

p {
    font-size: 18px;
    font-weight:500;
    line-height:22px;
    margin-bottom:0;
}
.card-block img{
  /* width:100%;
    height:300px;
    object-fit: cover; -*/
    width:100%;
    height: 200px;
    object-fit: contain;

}

@media(max-width:1200px){
    .card-header p{
        font-size:16px;
    }
}

.card-block {
  display: flex;
  flex-direction: column;
  align-items: center; /* Qendron horizontalisht */
  height: 100%;
}
.imageBox {
    width: 80%;
    margin: 0 auto;
    height: 200px;

}
.bottom-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto; /* Shton hapësirë sipër dhe e shtyn këtë div në fund */
}

</style>